<div class="modal-header">
  <h4 class="modal-title header-5">
    {{ configs.title }}
  </h4>
  <button
    type="button"
    class="accello-icon-btn"
    (mousedown)="isActive = true"
    (mouseup)="isActive = false"
    (mouseleave)="isActive = false"
    (click)="activeModal.dismiss('Cross click')"
  >
    <img
      [src]="
        isActive
          ? 'assets/images/virtusa-icons/close-dark.svg'
          : 'assets/images/virtusa-icons/close.svg'
      "
      alt="Close"
    />
  </button>
</div>

<div class="modal-body agent-modal">
  <div class="mb-3">
    <label class="form-label general-text-6">
      Upload Defect Report
      <span class="text-danger">*</span>
    </label>

    <div
      class="file-upload-area"
      [class.drag-over]="isDragOver"
      (drop)="onDrop($event)"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
    >
      <div class="upload-icon">
        <img
          src="assets/images/virtusa-icons/add-outline-gray.svg"
          alt="upload"
        />
      </div>
      <div class="upload-text">
        <label class="file-chooser">
          Add your defect report here (only.csv)
          <input
            type="file"
            accept=".csv"
            (change)="onFileSelected($event)"
            hidden
          />
        </label>
      </div>
      <div class="selected-file" *ngIf="selectedFile">
        <i class="ri-file-line"></i> {{ selectedFile.name }}
      </div>
    </div>
    <div
      *ngIf="defectFileControl.invalid && defectFileControl.touched"
      class="text-danger mt-1"
    >
      <span *ngIf="defectFileControl.hasError('required')"
        >Test Cases file is required</span
      >
      <span *ngIf="defectFileControl.hasError('invalidFileType')"
        >Only CSV files are allowed</span
      >
      <span *ngIf="defectFileControl.hasError('fileNameHasSpace')"
        >File name must not contain spaces</span
      >
    </div>
  </div>

  <div class="divider"></div>

  <div class="mb-3">
    <label
      class="header-coverage-high d-flex align-items-center"
      for="githubUrl"
    >
      <input
        type="checkbox"
        class="form-check-input me-2"
        style="margin-top: 0"
        [(ngModel)]="showGithubUrl"
      />
      Update GitHub Repo Link
    </label>
  </div>

  <div class="mb-3" *ngIf="showGithubUrl">
     <label class="form-label general-text-6">
      GitHub Repo Link
      <span class="text-danger">*</span>
    </label>
    <input
      type="text"
      id="githubLink"
      class="form-control"
      [(ngModel)]="configs.data.githubLink"
      placeholder="Enter GitHub repository URL"
    />
  </div>
</div>

<div class="modal-footer">
  <div class="d-flex justify-content-end">
    <button
      class="btn-accello-secondary mx-2"
      (click)="activeModal.dismiss('Cross click')"
    >
      Cancel
    </button>
    <button 
      class="btn-accello-primary-light" 
      (click)="save()"
      [disabled]="!selectedFile || (showGithubUrl && !configs.data.githubLink)"
    >
      {{ configs?.saveBtnText ? configs.saveBtnText : "Save" }}
    </button>
  </div>
</div>
